// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"67951230","460":"aafd7899","891":"d8cc60e0"}[chunkId] + ".chunk.js";
};